const setOrderStatus = function (state, data) {
    state.orderStatus = data
}

const setOrderTrackingDetails = function (state, data) {
    state.trackingDetails = data
}

const resetState = function (state) {
    state.orderStatus = null
    state.trackingDetails = null
}

export default {
    setOrderStatus,
    setOrderTrackingDetails,
    resetState,
}
